import { HeroSection } from '../components/HeroSection';
import { ServicesBentoGrid } from '../components/ServicesBentoGrid';
import { AboutSection } from '../components/AboutSection';
import { TestimonialCarousel } from '../components/TestimonialCarousel';
import { CaseStudiesPreview } from '../components/CaseStudiesPreview';
import { NewsPreview } from '../components/NewsPreview';
import { ContactForm } from '../components/ContactForm';
import { Seo } from '../components/Seo';

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <Seo path="/" />
      <HeroSection />
      <ServicesBentoGrid />
      <AboutSection />
      <TestimonialCarousel />
      <CaseStudiesPreview />
      <NewsPreview />
      <ContactForm />
    </main>
  );
}
